<template>
  <div class="login-card__location-card">
    <div class="login-card__title-box mb-3">
      <h1 class="login-card__title" id="location-header">
        {{ trans.get('auth.card.city.header') }}
      </h1>
      <p class="login-card__title-desc">{{ trans.get('auth.card.city.subheader') }}</p>
    </div>

    <div>
      <validation-observer ref="form" v-slot="{ handleSubmit }">
        <div class="row">
          <div class="col-12">
            <validation-provider name="data" v-slot="{ errors }" mode="eager">
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>
        <form @submit.prevent="handleSubmit(onSubmit)">
          <input-location v-model="form.location_id" :placeholder="trans.get('auth.card.city.placeholder')"></input-location>
          <p class="login-card__desc">{{ trans.get('auth.card.city.label') }}</p>
          <button type="submit" id="finish-button" class="button button__fill button--w-100 mt-5 text--smedium">
            {{ trans.get('auth.card.city.continue') }}
          </button>
        </form>
      </validation-observer>

      <button type="button" class="button button__link button__link--underline mt-3 text--smedium" @click="goBack">
        {{ trans.get('auth.card.buttons.back') }}
      </button>

      <!--      <p-->
      <!--        class="login-card__title-desc"-->
      <!--        v-html="trans.get('auth.card.registration_agreement', { link1: zRoute('page.agb'), link2: zRoute('page.privacy') })"-->
      <!--      ></p>-->
    </div>
  </div>
</template>
<script>
import InputLocation from './InputLocation';
import RegisterMixin from '../../../front/components/Auth/RegisterMixin';
import AuthGoBackMixin from '../../../front/components/Auth/AuthGoBackMixin';

export default {
  mixins: [RegisterMixin, AuthGoBackMixin],
  components: { InputLocation },
  props: ['swapComponent', 'form'],
  methods: {
    onSubmit() {
      // const self = this;

      // if (self.form.isLoggedId && self.form.email) {
      //   this.updateUser()
      //     .then(() => {
      //       setTimeout(() => {
      //         window.location.href = zRoute('front.members.index');
      //       }, 10);
      //     });
      // } else {
      this.swapComponent('auth-gender-card');
      // }

      // axios
      //   .put(zRoute('register.update'), self.getPreparedData())
      //   .then(function (response) {
      //     if (response.data.status === 'success') {
      //
      //       self.$store.dispatch('analytics/gtagEvent', {
      //         event: 'doi',
      //         p: {
      //           'event_category': 'User Registration',
      //           'event_label': 'DOI Registration'
      //         }
      //       });
      //
      //       setTimeout(() => {
      //         window.location.href = zRoute('front.members.index');
      //       }, 10);
      //     } else {
      //       self.$refs.form.setErrors({ data: [self.trans.get('auth.card.data_update_failed')] });
      //     }
      //   }, function (error) {
      //     const errors = error.response.data.errors;
      //
      //     if (error.response.status === 422) {
      //       self.$refs.form.setErrors({ data: errors[Object.keys(errors)[0]] });
      //     }
      //   });
    },
    goBack() {
      this.swapComponent('auth-birthday-card');
    }
  },
  activated() {
    this.$emit('update:progress', 40);
    this.$emit('update:step', 2);
  },
};
</script>
<style scoped></style>
